<template>
  <ul>
    <li class="edit-sidebar">
      <template v-if="this.admin">
        <!--<div class="edit" v-show="adminmode === 0" @click="editMode">
          <i class="fa fa-edit"></i>
        </div>
        <div class="view" v-show="adminmode === 1" @click="viewMode">
          <i class="fa fa-eye"></i>
        </div>
        <div class="add" @click="addItem">
          <i class="fa fa-plus"></i>
        </div>-->
      </template>
    </li>
    <dashboard-menu-item
      :adminmode="adminmode"
      v-for="item in items"
      :key="item.id"
      :item="item"
      @item-updated="updateItem($event)"
    ></dashboard-menu-item>
  </ul>
</template>

<script>
import item from "./dashboardMenuItem";

export default {
  created() {
    this.fetchDashboards();
  },
  props: {
    admin: Number
  },
  components: {
    item
  },

  methods: {
    editMode() {
      this.adminmode = 1;
      $(".sortableMenu").sortable({
        handle: "i.handle",
        update: function(event, ui) {
          var itemOrder = $(".sortableMenu").sortable("toArray");
          $.ajax("/dashboards/updateOrder", {
            method: "PUT",
            headers: {
              "X-CSRF-TOKEN": window._token
            },
            data: {
              order: itemOrder
            },
            success: function(res) {
              console.log("ok");
            },
            error: function(err, a, b) {
              alert("Not Saved");
            }
          });
        }
      });
      $(".sortableMenu").disableSelection();
    },
    viewMode() {
      this.adminmode = 0;
    },
    fetchDashboards() {
      const t = this;
      axios.defaults.baseURL = process.env.MIX_APP_URL;
      axios.get("/dashboards/").then(({ data }) => {
        t.items = data;
      });
    },
    addItem() {
      var data = {
        title: "new Dashboard",
        icon: "fa-user"
      };
      const t = this;
      t.items.push(data);
    },
    updateItem($event) {
      const t = this;
        axios.defaults.baseURL = process.env.MIX_APP_URL;

      axios.put(`/dashboards/${$event.id}`, $event).then(({ data }) => {
        t.items[t.itemIndex($event.id)].title = data.title;
      });
    },
    itemIndex(itemId) {
      return this.items.findIndex(element => {
        return element.id === itemId;
      });
    }
  },
  data: function() {
    return {
      state: "default",
      data: {
        title: ""
      },
      counter: 0,
      items: [],
      adminmode: 0
    };
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/dashboardMenu.vue